import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { useMenuAIAutomationLayoutContext } from 'widgets/Menu/ui/MenuAIAutomation'
import { ClickToTextPageStore } from 'pages/clickToText'
import { ClickToTextPageContext } from '../context/clickToTextPageContext'

export const ClickToTextPageLayout = observer(() => {
  const menuLayoutStore = useMenuAIAutomationLayoutContext()
  const entities = useEntitiesContext()
  const [clickToTextStore] = useState(
    () => new ClickToTextPageStore(menuLayoutStore.pageLayoutStore, entities)
  )

  return (
    <ClickToTextPageContext.Provider value={clickToTextStore}>
      <Outlet />
    </ClickToTextPageContext.Provider>
  )
})
